import React from "react";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";

type UnitFactorMessagingProps = {
  qty: number;
};

export const UnitFactorMessaging = ({ ...props }: UnitFactorMessagingProps) => {
  return (
    <div className="wbm-text-gray d-flex align-items-center">
      <InfoOutlinedIcon className="space" />
      <span>This item is only sold in multiples of {props.qty}.</span>
    </div>
  );
};
